export interface InvoiceToCustomerRequest{
  account_id: string;
  project_id?: string;
  customer_id?: string;
  invoice_id?: string;
  recipient_email: string;
  recipient_phone: string;
  send_method: string;
  message_for: string; 
}

export interface Invoice {
    invoice_id: string;
    name: string;
    payment_instruction: string;
    tax_rate: number;
    amount_paid: number;
    payment_method?: string;  // Add this
    payment_date?: string;    // Add this
    note?: string;   
    discount_usd: number;
    sub_total_sum_lineitems: number;
    sub_total_after_tax: number;
    tax_amount: number;
    final_total: number;
    issue_date: string;
    due_date: string;
    project_id: string;
    customer_id: string;
  }

  export interface InvoiceWithItemsRequest {
    name: string;
    payment_instruction: string;
    tax_rate: number;
    amount_paid: number;
    discount_usd: number;
    issue_date: string;
    due_date: string;
    project_id: string;
    customer_id: string;
    payment_date: string;
    payment_method: string;
    note: string;
    itemized_invoices: Array<{
      code: string;
      description: string;
      amount_dollar: number;
    }>;
  }

  export interface ItemizedInvoice {
    itemized_invoice_id: string;
    code: string;
    description: string;
    amount_dollar: number;
    invoice_id: string;
  }


  export interface CreateItemizedInvoiceRequest {
    code: string;
    description: string;
    amount_dollar: number;
    invoice_id: string;
  }
  
  export interface InvoiceTotals {
    sub_total_sum_lineitems: number;
    sub_total_after_tax: number;
    tax_amount: number;
    final_total: number;
    balance_due: number;
    total_amount_paid: number;
  }

  // New interface for itemized invoice totals from API response
  export interface ItemizedInvoiceTotals {
    sub_total: number;
    tax_rate: number;
    tax_amount: number;
    discount_usd: number;
    amount_paid: number;
    balance: number;
  }

  // Response type for getItemizedInvoices
  export interface GetItemizedInvoicesResponse {
    itemizedInvoices: ItemizedInvoice[];
    totals: ItemizedInvoiceTotals;
  }

  export interface LineItem {
    id: number;
    code: string;
    description: string;
    amount_dollar: number;
    invoice_id: string;
  }

  export interface InvoiceProjectCustomer {
    invoice_id: string;
    name: string;
    payment_instruction: string;
    tax_rate: number;
    amount_paid: number;
        // Payment fields from payments array
    payment_method?: string;
    payment_date?: string;
    note?: string;
    
    discount_usd: number;
    issue_date: string;
    due_date: string;
    sub_total_sum_lineitems: number;
    sub_total_after_tax: number;
    tax_amount: number;
    final_total: number;
    project_id: string;
    customer_id: string;

    project_name: string;
    project_description: string;
    project_type: string;
    project_start_date: string;
    project_end_date: string; 
    customer_first_name: string;
    customer_last_name: string;    
    customer_address_1: string;
    customer_address_2?: string;
    customer_city: string;
    customer_state: string;
    customer_zip: string;
    customer_phone: string;
    customer_email: string;
  }


 export const default_payment_instruction = 
   "We only accept cash, money orders, checks, bank transfers (such as Zelle), or credit cards. Please send any payment due.";